import { forwardRef } from "react";

/** Background that sits behind modal dialogs. */
export const ModalBackdrop = forwardRef<HTMLDivElement>((_props, ref) => (
  <div
    ref={ref}
    // The entering/exiting data attributes work when used with react-aria-components.
    // Fading the layer's opacity fades tint and blur together; there is no
    // `backdrop-blur-0` utility to transition the filter itself against.
    className="absolute inset-0 bg-gray-950/30 opacity-100 backdrop-blur-[1px] transition-opacity duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] group-data-[entering]:opacity-0 group-data-[exiting]:opacity-0 motion-reduce:transition-none"
  />
));
